import { PUBLISH_STATUSES } from "constants/models";

export const getConfirmRemovalText = ({
  entity,
  suffix,
  category,
}: {
  entity: any;
  suffix: string;
  category: any;
}) => {
  const name = [entity.label || entity.title, suffix].join(" ");
  const publishedStatuses = [
    PUBLISH_STATUSES.PUBLISHED,
    PUBLISH_STATUSES.SCHEDULE_FOR_REMOVE,
  ];

  const isPublished =
    publishedStatuses.includes(entity.publishStatus) &&
    publishedStatuses.includes(category.publishStatus);

  return !isPublished
    ? `Are you sure you want to remove ${name} from ${category.title} category?`
    : `Are you sure you want to remove ${name} from ${category.title} category? It will no longer be displayed to app users in production.`;
};
